import { Component, Prop, Vue} from "vue-property-decorator";
import { ProductListModuleModel, Product, UiState, ConfiguratorValueUpdateModel, configuratorConstants } from "../models";
import { productConfiguratorStore as store } from "./../store";
import HtmlElementHelper from "@/services/HtmlElementHelper";
import ProductSpecification from "./ProductSpecification";
import Cookie from "@/services/Cookie";
import CarbonSavingsCalculation from "../../../components/ProductPage/CarbonSavingsCalculation";

@Component({
    components: {
        ProductSpecification,
        CarbonSavingsCalculation
  }
})

export default class ProductListModule extends Vue {
    @Prop()
    protected vm!: ProductListModuleModel;
    protected productStates: Array<UiState<boolean>> = [];
    protected productsInCookie: string[] = [];
    protected carbonSavingsProductStates: Array<UiState<boolean>> = [];

    protected created() {
        this.vm.products.forEach(p => this.productStates.push({ id: p.articleNumber} as UiState<boolean>));
        this.vm.products.forEach(p => this.carbonSavingsProductStates.push({ id: p.articleNumber} as UiState<boolean>));

        const cookieString = Cookie.getCookie(configuratorConstants.selectedConfiguratorProducts + store.configuratorType);

        if (cookieString) {
            const cookieArray = JSON.parse(cookieString);
            for (const cookie of cookieArray) {
                if (cookie.value) {
                    if (cookie.propertyName === configuratorConstants.productList) {
                        const productList = JSON.parse(cookie.value);
                        if (productList.length) {
                            for (const tempproduct of productList) {
                                this.productsInCookie.push(tempproduct);
                                const matchingProduct = store.products.find(x => x.articleNumber === tempproduct);
                                if (matchingProduct) {
                                    this.addProduct(matchingProduct);
                                }
                            }
                        } else {
                            this.productsInCookie.push(productList);
                            this.addProduct(productList);
                        }
                    }
                }
            }
        }
    }

    protected toggleProductSpecification(product: Product) {
        const productStateIndex = this.productStates.findIndex(s => s.id === product.articleNumber);
        if (productStateIndex !== -1) {
            const productState = this.productStates[productStateIndex];
            productState.state = !productState.state;
            this.productStates.splice(productStateIndex, 1, productState);
        }
    }

    protected showProductSpecification(product: Product): boolean {
        if (product) {
            const productState = this.productStates.find(s => s.id === product.articleNumber);
            if (productState) {
                return productState.state;
            }
        }
        return false;
    }

    protected addProduct(product: Product) {
        if (product.confirmedQuantity > 0 || this.vm.hideQuantity) {
            if (this.vm.addOnlyOneProduct) {
                store.products.map(a => this.vm.products.map(b => {
                    if (b.articleNumber === a.articleNumber) {
                        a.added = false;
                    }
                }));
            }
            product.added = true;
            store.updateProduct(product);

            if (this.vm.showSelectText) {
                const currentValue = store.propertyModelValues.filter(x => x.key === configuratorConstants.recommendedProductSelected);
                if (currentValue) {
                    let valueData = currentValue[0].value;
                    if (valueData && !this.vm.addOnlyOneProduct) {
                        if (valueData.indexOf(product.articleNumber + "$") < 0) {
                            valueData = valueData + product.articleNumber + "$";
                        }
                    } else {
                        if (this.vm.addOnlyOneProduct) {
                            this.vm.products.map(x => {
                                if (valueData) {
                                    valueData = valueData.replace(x.articleNumber + "$", "");
                                }
                            });
                            valueData = valueData + product.articleNumber + "$";
                        } else {
                            valueData = product.articleNumber + "$";
                        }
                    }

                    const updateModelRecommended: ConfiguratorValueUpdateModel = { moduleId: this.vm.id, value: valueData, valueDescriptions: [{ title: "", text: "" }],
                    propertyName: configuratorConstants.recommendedProductSelected, isText: false, resetClimateSavingsCookie: false };
                    this.$emit("update-configurator-value", updateModelRecommended, true);
                }
            } else {
                const updateModel: ConfiguratorValueUpdateModel = { moduleId: this.vm.id, value: product.articleNumber, valueDescriptions: [{ title: "", text: "" }],
                propertyName: configuratorConstants.productList, isText: false, resetClimateSavingsCookie: false };
                this.$emit("update-configurator-value", updateModel, true);
            }
        }
    }

    protected removeProduct(product: Product) {
        product.added = false;
        store.updateProduct(product);

        if (this.vm.showSelectText) {
            const currentValue = store.propertyModelValues.filter(x => x.key === configuratorConstants.recommendedProductSelected);
            if (currentValue) {
                let valueData = currentValue[0].value;
                if (valueData.indexOf(product.articleNumber + "$") > -1) {
                    valueData = valueData.replace(product.articleNumber + "$", "");
                }

                const updateModelRecommended: ConfiguratorValueUpdateModel = { moduleId: this.vm.id, value: valueData, valueDescriptions: [{ title: "", text: "" }],
                propertyName: configuratorConstants.recommendedProductSelected, isText: false, resetClimateSavingsCookie: false };
                this.$emit("update-configurator-value", updateModelRecommended, true);
            }
        } else {
            const updateModel: ConfiguratorValueUpdateModel = { moduleId: this.vm.id, value: product.articleNumber, valueDescriptions: [{ title: "", text: "" }],
            propertyName: configuratorConstants.productList, isText: false, resetClimateSavingsCookie: false };
            this.$emit("update-configurator-value", updateModel, true);
        }
    }

    protected isProductAdded(product: Product): boolean {
        if (this.vm.showSelectText) {
            return store.propertyModelValues.some(x => x.key === configuratorConstants.recommendedProductSelected
                && x.value && x.value.indexOf(product.articleNumber + "$") > -1);
        } else {
            return store.products
            .some(x => x.articleNumber === product.articleNumber && (x.confirmedQuantity > 0 || this.vm.hideQuantity) && x.added);
        }
    }

    protected getButtonText(product: Product): string {
        if (this.isProductAdded(product)) {
            return this.vm.showSelectText ? this.translations.selectedProductButtonText : this.translations.addedProductButtonText;
        }
        return this.vm.showSelectText ?  this.translations.selectProductButtonText : this.translations.addProductButtonText;
    }

    protected handleQuantityUpdate(event: Event, product: Product) {
        if (event.target instanceof HTMLInputElement && !HtmlElementHelper.isValidNumberInput(event.target)) {
            product.confirmedQuantity = Number(event.target.min);
        }

        if (product.confirmedQuantity === 0) {
            this.removeProduct(product);
        }
    }

    protected getCarbonSavingsProductState(product: Product) {
        return this.carbonSavingsProductStates.find(ps => ps.id === product.articleNumber);
    }

    protected toggleCarbonSavingsInfo(product: Product) {
        const productStateIndex = this.carbonSavingsProductStates.findIndex(s => s.id === product.articleNumber);
        if (productStateIndex !== -1) {
            const productState = this.carbonSavingsProductStates[productStateIndex];
            productState.state = !productState.state;
            this.carbonSavingsProductStates.splice(productStateIndex, 1, productState);
        }
    }

    protected showCarbonSavingsInfo(product: Product): boolean {
        const productState = this.getCarbonSavingsProductState(product);
        if (productState) {
            return productState.state;
        }
        return false;
    }

    get products() {
        return this.vm.hideQuantity ?  this.vm.products.sort((a, b) => {
            return a.name.localeCompare(b.name, "sv", { numeric: true});
          }) :
        store.products.filter(x => this.vm.products.map(p => p.articleNumber).includes(x.articleNumber)).sort((a, b) => {
            return a.name.localeCompare(b.name, "sv", { numeric: true});
          });
    }

    get hasDisplayedProducts() {
        return this.products.some(x => x.calculatedQuantity > 0) || this.vm.hideQuantity;
    }

    get translations() {
        return store.translations;
    }
}
